import styled from 'styled-components';
import TxtField01 from 'dc/TxtField01';
import { Typ30 } from 'dc/Typ';
import Btn026 from 'dc/Btn026';
import Btn020 from 'dc/Btn020';
import SpaHR03 from 'dc/SpaHR03';
import SpaHR04 from 'dc/SpaHR04';

export const Container = styled.div`
  width: 458px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  margin: 50px 0 60px;
  padding: 26px 77px 68px 77px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img``;

export const Input = styled(TxtField01)`
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px #f4f7f9 inset !important;
  }
`;

export const TermsText = styled(Typ30)`
  color: #0099a9;
  font-weight: bold;
  cursor: pointer;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  background-color: transparent;
  width: 288px;
`;

export const NewUserText = styled(Typ30)`
  color: rgba(38, 50, 56, 0.7);
  max-width: 180px;
`;

export const LoginButton = styled(Btn020)`
  background-color: transparent;
  border: 0;
  span {
    color: #007079;
  }
`;

export const SpacerText = styled(SpaHR04)`
  width: 288px;
  span {
    color: #546e7a;
  }
`;

export const SpacerLine = styled(SpaHR03)`
  width: 288px;
`;

export const RegisterButton = styled(Btn026)`
  margin-bottom: 12px;
`;

export const EmailButton = styled(Btn020)`
  width: 288px;
  margin-top: 2px;
  margin-bottom: 30px;
  span {
    color: #007079;
  }
`;
